<template>
  <div class="pc-center">
    <div class="left-bar">
      <div
        :class="[{'on':current_page==index}]"
        :key="index"
        @click="cut(index)"
        v-for="(name,index) in page_c_names"
      >
        <a>{{name}}</a>
      </div>
    </div>
    <div class="right-content">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ACenterFrame',
  componentName: 'ACenterFrame',
  data () {
    return {
      current_page: 0,
      page_map: {
        personalData: 0,
        customList: 1,
        agentOrderList: 2,
        aMsgList: 3
      },
      page_names: ['personalData', 'customList', 'agentOrderList', 'aMsgList'],
      page_c_names: ['我的资料', '我的客户', '我的订单', '我的消息'],
    }
  },
  created () {
    this.init()
  },
  updated () {
    this.init()
  },
  methods: {
    cut (i) {
      this.$pushByName(this.page_names[i])
    },
    init () {
      let currentRoute = this.$router.currentRoute
      this.current_page = this.page_map[currentRoute.name] ? this.page_map[currentRoute.name] : 0
    }
  }
}
</script>

<style>
@import '../../../assets/css/pages/customer/center.css';
</style>


// WEBPACK FOOTER //
// src/pages/agent/p_center/aCenterFrame.vue